export enum Size {
  Auto = 'auto',
  Full = '100%',
  ThreeQuaters = '75%',
  TwoThird = '67%',
  Half = '50%',
  Third = '33%',
  Quater = '25%',
}
